module.exports = "https://cdn.hellotech.com/client-assets/wallmount_fullmotion_cadec182d5f9c1d280f4910f67064be8.png";